import {
  ChangeDetectionStrategy,
  Component,
  signal,
  WritableSignal,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Track } from '@app/core/models/Track';
import { PlayAudio, Resume, Stop } from '@app/core/states/audio.actions';
import { AudioState } from '@app/core/states/audio.state';
import {
  TRACK_ACTION,
  TrackContextMenuComponent,
} from '@app/library/components/modals/track-context-menu/track-context-menu.component';
import { ResetEditingTracks } from '@app/library/states/editing-track.actions';
import { EditingTrackState } from '@app/library/states/editing-track.state';
import { MOBILE_DIALOG_CONFIG } from '@app/shared/constants';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Select, Store } from '@ngxs/store';
import { DynamicEnabledPanel } from '@radioking/shared/pannel-manager';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-track-details',
  templateUrl: './track-details.component.html',
  styleUrls: ['./track-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrackDetailsComponent implements DynamicEnabledPanel {
  @Select(EditingTrackState.track)
  track$: Observable<Track>;

  @Select(AudioState.currentTrackPlaying)
  currentTrackPlaying$: Observable<Track>;

  @Select(AudioState.isPlaying)
  isPlaying$: Observable<boolean>;

  $editing: WritableSignal<boolean> = signal(false);
  $closing: WritableSignal<boolean> = signal(false);

  constructor(
    private readonly store: Store,
    private readonly dialog: MatDialog,
  ) {}

  hide() {
    if (this.$editing()) {
      setTimeout(() => {
        this.$editing.set(false);
      }, 400);
      this.$closing.set(true);
    } else {
      this.store.dispatch(new ResetEditingTracks());
    }
  }

  @Dispatch()
  playTrack(track: Track) {
    const currentTrackPlaying = this.store.selectSnapshot(AudioState.currentTrackPlaying);
    const isPlaying = this.store.selectSnapshot(AudioState.isPlaying);
    if (currentTrackPlaying?.id === track.id) {
      if (isPlaying) {
        return new Stop();
      } else {
        return new Resume();
      }
    }

    return new PlayAudio(track);
  }

  openContextMenu() {
    const dialogRef = this.dialog.open(TrackContextMenuComponent, MOBILE_DIALOG_CONFIG);
    dialogRef.afterClosed().subscribe(event => {
      if (event && event.action && event.action === TRACK_ACTION.EDIT) {
        this.editTrack();
      }
    });
  }

  editTrack() {
    this.$editing.set(true);
    this.$closing.set(false);
  }

  trackPlaying(track: Track, currentTrack: Track, isPlaying: boolean) {
    return currentTrack?.id === track?.id && isPlaying;
  }

  hasToShowConfirmOnExit(): boolean {
    return false;
  }

  isDirty(): boolean {
    return false;
  }
}
